<template>
  <v-app>
    <div class="row">
      <div class="col-md-4" style="float: left; min-width: 200px">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                { active: leftSideBarTabSelected === 'subdivisions' },
              ]"
              href="#subdivisions"
              data-toggle="tab"
              @click="leftSideBarTabSelected = 'subdivisions'"
              >{{ $ml.get("users.subdivision") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="[
                'nav-link',
                { active: leftSideBarTabSelected === 'departments' },
              ]"
              href="#departments"
              data-toggle="tab"
              @click="leftSideBarTabSelected = 'departments'"
              >{{ $ml.get("users.departments") }}</a
            >
          </li>
        </ul>

        <div class="tab-content">
          <div
            :class="[
              'tree-group-list',
              'tab-pane',
              'add-new-visitor-form-container',
              {
                'tree-group-list--active':
                  leftSideBarTabSelected === 'subdivisions',
              },
            ]"
            id="subdivisions"
          >
            <div class="panel" v-if="isSdvEdit()">
              <button
                class="btn btn-primary v-icon mdi mdi-shape-circle-plus mr-1"
                @click="addCompany"
                :title="$ml.get('subdiv.addNewSubdivision')"
              />
              <button
                v-if="companyActive.id !== null && companyActive.id > 0"
                class="btn btn-primary v-icon mdi mdi-circle-edit-outline mr-1"
                @click="editCompany"
                :title="$ml.get('subdiv.makeChanges')"
              />
              <button
                v-if="companyActive.id !== null && companyActive.id > 0"
                class="btn btn-danger v-icon mdi mdi-delete-circle-outline"
                @click="deleteCompany"
                :title="$ml.get('subdiv.deleteSelected')"
              />
            </div>
            <v-card class="tree-group-list__card">
              <div class="tree-group-list__btns">
                <a
                  :class="[
                    'tree-group-list__top-btn',
                    {
                      'tree-group-list__top-btn--active':
                        companyActive.id === null,
                    },
                  ]"
                  @click="
                    selectCompany(
                      {
                        id: null,
                        parent_id: null,
                        name: $ml.get('users.all_subdivisions'),
                      },
                      $event
                    )
                  "
                >
                  <v-icon class="mr-2">mdi-account-check</v-icon>
                  {{ $ml.get("users.all_subdivisions") }}
                </a>
                <a
                  :class="[
                    'tree-group-list__top-btn',
                    {
                      'tree-group-list__top-btn--active':
                        companyActive.id === -1,
                    },
                  ]"
                  @click="
                    selectCompany(
                      {
                        id: -1,
                        parent_id: null,
                        name: $ml.get('users.no_subdivisions'),
                      },
                      $event
                    )
                  "
                >
                  <v-icon class="mr-2">mdi-account-cancel</v-icon>
                  {{ $ml.get("users.no_subdivisions") }}
                </a>
              </div>
              <v-list v-if="treeOpen" class="tree-group-list__tree">
                <v-treeview hoverable :items="tree" return-object>
                  <template
                    slot="label"
                    item-key="id"
                    item-text="name"
                    slot-scope="{ item }"
                  >
                    <a
                      :class="'treeitem ' + setTreeActiveClass(item)"
                      @click="selectCompany(item, $event)"
                      @dblclick="editCompany"
                      style="height: 100%; width: 100%; display: block"
                      >{{ item.name }}</a
                    >
                  </template>
                </v-treeview>
              </v-list>
            </v-card>
          </div>

          <div
            :class="[
              'tree-group-list',
              'tab-pane',
              'add-new-visitor-form-container',
              {
                'tree-group-list--active':
                  leftSideBarTabSelected === 'departments',
              },
            ]"
            id="departments"
          >
            <div class="panel">
              <button
                v-if="isDepAdd"
                class="btn btn-primary v-icon mdi mdi-shape-circle-plus mr-1"
                @click="addDepartment"
                :title="$ml.get('departments.addNew')"
              ></button>
              <button
                v-if="selectedDepartment && isDepEdit"
                class="btn btn-primary v-icon mdi mdi-circle-edit-outline mr-1"
                @click="editDepartment"
                :title="$ml.get('departments.change')"
              />
              <button
                v-if="selectedDepartment && isDepDel"
                class="btn btn-danger v-icon mdi mdi-delete-circle-outline"
                @click="deleteDepartment"
                :title="$ml.get('departments.delete')"
              />
            </div>

            <v-card class="tree-group-list__card">
              <v-list class="tree-group-list__tree">
                <v-treeview
                  return-object
                  open-all
                  hoverable
                  activatable
                  :items="departmentsTree"
                  @update:active="onSelectDepartment"
                />
              </v-list>
            </v-card>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <notifications group="info" position="top right" />
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              :class="'nav-link' + activeBlock('all')"
              href="#users-all"
              data-toggle="tab"
              @click="setTab('all')"
              >{{ $ml.get("users.users") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="'nav-link' + activeBlock('blocks')"
              href="#users-blocked"
              data-toggle="tab"
              @click="setTab('blocks')"
              >{{ $ml.get("users.blocked") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="'nav-link' + activeBlock('blacks')"
              href="#users-blacklisted"
              data-toggle="tab"
              @click="setTab('blacks')"
              >{{ $ml.get("users.blacklist") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="'nav-link' + activeBlock('errors')"
              href="#users-errors"
              data-toggle="tab"
              @click="setTab('errors')"
              >{{ $ml.get("users.errors") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              :class="'nav-link' + activeBlock('deleted')"
              href="#users-deleted"
              data-toggle="tab"
              @click="setTab('deleted')"
              >{{ $ml.get("users.deleted") }}</a
            >
          </li>
        </ul>
        <div class="tab-content">
          <div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('all')
            "
            id="users-all"
          >
            <v-row>
              <v-col cols="12" md="auto">
                <v-row>
                  <v-col cols="auto">
                    <div class="dropdown">
                      <button
                        class="btn btn-primary dropdown-toggle leftmenu"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        type="button"
                        aria-expanded="true"
                        name="actionAllUser"
                      >
                        {{ $ml.get("menu.actions") }}
                        &nbsp;
                        <span class="caret"></span>
                      </button>
                      <div class="dropdown-menu">
                        <template
                          v-if="getSelectCount('all') > 0 && isEditUser()"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            name="sdvUpd"
                            @click="multiSdv('sdv_upd', 'all')"
                            >{{ $ml.get("menu.setSdv") }}</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            name="sdvAdd"
                            @click="multiSdv('sdv_add', 'all')"
                            >{{ $ml.get("menu.addUserSdv") }}</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            name="sdvDel"
                            @click="multiSdv('sdv_del', 'all')"
                            >{{ $ml.get("menu.delUserSdv") }}</a
                          >
                          <div class="dropdown-divider"></div>
                          <a
                            class="dropdown-item"
                            href="#"
                            name="dptUpd"
                            @click="multiDpt('all')"
                            >{{ $ml.get("menu.setDpt") }}</a
                          >
                          <div class="dropdown-divider"></div>
                          <a
                            class="dropdown-item"
                            href="#"
                            name="Block"
                            @click="multiBlock('block', 'all')"
                            >{{ $ml.get("button.block") }}</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            name="addBlacklist"
                            @click="multiBlack('set', 'all')"
                            >{{ $ml.get("button.add_blacklist") }}</a
                          >
                        </template>
                        <template
                          v-if="getSelectCount('all') > 0 && isDelUser()"
                        >
                          <div class="dropdown-divider"></div>
                          <a
                            class="dropdown-item"
                            href="#"
                            name="delete"
                            @click="multiDelete('all')"
                            >{{ $ml.get("button.delete") }}</a
                          >
                        </template>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click="reportUsers()"
                          >{{ $ml.get("button.reportUsers") }}</a
                        >
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="auto">
                    <div class="dropdown">
                      <button
                        class="btn btn-light dropdown-toggle leftmenu"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        type="button"
                        aria-expanded="true"
                        name="actionAllUser"
                      >
                        {{ $ml.get("users.filter") }} [{{
                          $ml.get("users.filter_" + filter)
                        }}] &nbsp;
                        <span class="caret"></span>
                      </button>
                      <div class="dropdown-menu">
                        <a
                          class="dropdown-item"
                          href="#"
                          @click="getUsers('all')"
                          >{{ $ml.get("users.all") }}</a
                        >
                        <a
                          class="dropdown-item"
                          href="#"
                          @click="getUsers('guest')"
                          >{{ $ml.get("users.guests") }}</a
                        >
                        <a
                          class="dropdown-item"
                          href="#"
                          @click="getUsers('employee')"
                          >{{ $ml.get("users.employees") }}</a
                        >
                        <a
                          class="dropdown-item"
                          href="#"
                          @click="getUsers('manager')"
                          >{{ $ml.get("users.managers") }}</a
                        >
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer />
              <v-col v-if="isAddUser()" cols="12" md="auto">
                <router-link
                  :to="{ name: 'adduser' }"
                  class="btn btn-primary add"
                  :title="$ml.get('users.addNewUser')"
                  >{{ $ml.get("users.addUser") }}</router-link
                >
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <datatable
                  :fields="afields"
                  :rows="users['all'].data"
                  :rowstyle="styleRow"
                  :searchfn="searchfn"
                  :dblclick="showUser"
                  :select="true"
                >
                  {{ $ml.get("users.notUsers") }}
                  <template v-slot:header></template>
                  <template v-slot:footer>
                    <v-row>
                      <v-col cols="6" offset="3">
                        <vue-pagination
                          :pagination="users['all'].pagination"
                          @paginate="getUsers('all')"
                          :offset="offset"
                        />
                      </v-col>

                      <v-col cols="12" class="text-right">
                        <small
                          v-show="totalItems"
                          class="blue-grey--text text--lighten-1"
                        >
                          {{ `${$ml.get("users.total")}: ${totalItems}` }}
                        </small>
                      </v-col>
                    </v-row>
                  </template>
                </datatable>
              </v-col>
            </v-row>

            <v-app v-if="showAccessDialog">
              <AccessAdd
                v-model="selectUsers[tabSelect]"
                @toggle="closeAccessDialog($event)"
                :action="sdvAction"
              />
            </v-app>

            <v-app v-if="showDepartmentDialog">
              <DepartmentAdd
                v-model="selectUsers[tabSelect]"
                @toggle="closeDepartmentDialog($event)"
              />
            </v-app>
          </div>
          <!--div
            :class="
              'tab-pane add-new-visitor-form-container' +
              activeBlock('employee')
            "
            id="users-employees"
          >
            <datatable
              :fields="fields"
              :rows="users['employee'].data"
              :rowstyle="styleRow"
              :dblclick="showUser"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <vue-pagination
                  :pagination="users['employee'].pagination"
                  @paginate="getUsers('employee')"
                  :offset="offset"
                ></vue-pagination>
              </template>
            </datatable>
          </div-->
          <!--div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('guest')
            "
            id="users-guests"
          >
            <datatable
              :fields="fields"
              :rows="users['guest'].data"
              :rowstyle="styleRow"
              :dblclick="showUser"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <vue-pagination
                  :pagination="users['guest'].pagination"
                  @paginate="getUsers('guest')"
                  :offset="offset"
                ></vue-pagination>
              </template>
            </datatable>
          </div-->
          <div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('blocks')
            "
            id="users-blocked"
          >
            <div
              class="top-button-box"
              v-if="getSelectCount('blocks') > 0 && isEditUser()"
            >
              <span class="col-sm-6">
                <div class="dropdown" style="display: inline-block">
                  <button
                    style="margin-left: -20px"
                    class="btn btn-primary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    type="button"
                    aria-expanded="true"
                  >
                    {{ $ml.get("menu.actions") }}&nbsp;
                    <span class="caret"></span>
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="multiBlock('unblock', 'blocks', false)"
                      >{{ $ml.get("button.unblock") }}</a
                    >
                  </div>
                </div>
              </span>
            </div>

            <datatable
              :fields="afields"
              :rows="users.blocks.data"
              :dblclick="showUser"
              :rowstyle="styleRow"
              :select="true"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <v-row>
                  <v-col cols="6" offset="3">
                    <vue-pagination
                      :pagination="users.blocks.pagination"
                      @paginate="getUsers('blocks')"
                      :offset="offset"
                    />
                  </v-col>

                  <v-col cols="3" class="text-right">
                    <small
                      v-show="totalItems"
                      class="blue-grey--text text--lighten-1"
                    >
                      {{ `${$ml.get("users.total")}: ${totalItems}` }}
                    </small>
                  </v-col>
                </v-row>
              </template>
            </datatable>
          </div>
          <div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('blacks')
            "
            id="users-blacklisted"
          >
            <div
              class="top-button-box"
              v-if="getSelectCount('blacks') > 0 && isEditUser()"
            >
              <span class="col-sm-6">
                <div class="dropdown" style="display: inline-block">
                  <button
                    style="margin-left: -20px"
                    class="btn btn-primary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    type="button"
                    aria-expanded="true"
                  >
                    {{ $ml.get("menu.actions") }}&nbsp;
                    <span class="caret"></span>
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="multiBlack('unblack', 'blacks')"
                      >{{ $ml.get("button.remove_blacklist") }}</a
                    >
                  </div>
                </div>
              </span>
            </div>
            <datatable
              :fields="afields"
              :rows="users.blacks.data"
              :dblclick="showUser"
              :rowstyle="styleRow"
              :select="true"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <v-row>
                  <v-col cols="6" offset="3">
                    <vue-pagination
                      :pagination="users.blacks.pagination"
                      @paginate="getUsers('blacks')"
                      :offset="offset"
                    />
                  </v-col>

                  <v-col cols="3" class="text-right">
                    <small
                      v-show="totalItems"
                      class="blue-grey--text text--lighten-1"
                    >
                      {{ `${$ml.get("users.total")}: ${totalItems}` }}
                    </small>
                  </v-col>
                </v-row>
              </template>
            </datatable>
          </div>
          <div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('deleted')
            "
            id="users-deleted"
          >
            <div
              class="top-button-box"
              v-if="getSelectCount('deleted') > 0 && isDelUser()"
            >
              <span class="col-sm-6">
                <div class="dropdown" style="display: inline-block">
                  <button
                    style="margin-left: -20px"
                    class="btn btn-primary dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    type="button"
                    aria-expanded="true"
                  >
                    {{ $ml.get("menu.actions") }}&nbsp;
                    <span class="caret"></span>
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="multiRestore('deleted')"
                      >{{ $ml.get("button.restore") }}</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="multiClear('deleted')"
                      >{{ $ml.get("button.clear") }}</a
                    >
                    <a class="dropdown-item" href="#" @click="clearAll">{{
                      $ml.get("button.clearAll")
                    }}</a>
                  </div>
                </div>
              </span>
            </div>

            <datatable
              :fields="afields"
              :rows="users['deleted'].data"
              :rowstyle="styleRow"
              :dblclick="showUser"
              :select="true"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <v-row>
                  <v-col cols="6" offset="3">
                    <vue-pagination
                      :pagination="users['deleted'].pagination"
                      @paginate="getUsers('deleted')"
                      :offset="offset"
                    />
                  </v-col>

                  <v-col cols="3" class="text-right">
                    <small
                      v-show="totalItems"
                      class="blue-grey--text text--lighten-1"
                    >
                      {{ `${$ml.get("users.total")}: ${totalItems}` }}
                    </small>
                  </v-col>
                </v-row>
              </template>
            </datatable>
          </div>
          <div
            :class="
              'tab-pane add-new-visitor-form-container' + activeBlock('errors')
            "
            id="users-errors"
          >
            <div class="top-button-box" v-if="isAddUser()">
              <span class="col-sm-6">
                <div
                  v-if="isEditUser()"
                  class="dropdown"
                  style="display: inline-block"
                >
                  <button
                    style="margin-left: -20px"
                    class="btn btn-primary dropdown-toggle leftmenu"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    type="button"
                    aria-expanded="true"
                  >
                    {{ $ml.get("menu.actions") }}
                    &nbsp;
                    <span class="caret"></span>
                  </button>
                  <div class="dropdown-menu">
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiSdv('sdv_upd', 'errors')"
                      >{{ $ml.get("menu.setSdv") }}</a
                    >
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiSdv('sdv_add', 'errors')"
                      >{{ $ml.get("menu.addUserSdv") }}</a
                    >
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiSdv('sdv_del', 'errors')"
                      >{{ $ml.get("menu.delUserSdv") }}</a
                    >
                    <div
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-divider"
                    ></div>
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiBlock('block', 'errors')"
                      >{{ $ml.get("button.block") }}</a
                    >
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiBlock('unblock', 'errors', false)"
                      >{{ $ml.get("button.unblock") }}</a
                    >
                    <!-- <div v-if="getSelectCount('errors') > 0" class="dropdown-divider"></div> -->
                    <!-- <a
                      class="dropdown-item"
                      href="#"
                      @click="multiBlack('set', 'errors')"
                      >{{ $ml.get("button.add_blacklist") }}</a
                    > -->
                    <!-- <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#">Изменить статус пользователя</a>
                    <a class="dropdown-item" href="#">Установить тип допуска</a>-->
                    <!--div class="dropdown-divider"></div-->
                    <!-- <a class="dropdown-item" href="#">Создать отчет проходов</a> -->
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiDelete('errors')"
                      >{{ $ml.get("button.delete") }}</a
                    >
                    <div
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-divider"
                    ></div>
                    <a
                      v-if="getSelectCount('errors') > 0"
                      class="dropdown-item"
                      href="#"
                      @click="multiRefeature('errors')"
                      >{{ $ml.get("button.refeature") }}</a
                    >
                    <a class="dropdown-item" href="#" @click="reportErrors()">{{
                      $ml.get("button.reportErrors")
                    }}</a>
                  </div>
                </div>
              </span>
            </div>
            <datatable
              :fields="afields"
              :rows="users['errors'].data"
              :rowstyle="styleRow"
              :dblclick="showUser"
              :select="true"
            >
              {{ $ml.get("users.notUsers") }}
              <template v-slot:header></template>
              <template v-slot:footer>
                <v-row>
                  <v-col cols="6" offset="3">
                    <vue-pagination
                      :pagination="users['errors'].pagination"
                      @paginate="getUsers('errors')"
                      :offset="offset"
                    />
                  </v-col>

                  <v-col cols="3" class="text-right">
                    <small
                      v-show="totalItems"
                      class="blue-grey--text text--lighten-1"
                    >
                      {{ `${$ml.get("users.total")}: ${totalItems}` }}
                    </small>
                  </v-col>
                </v-row>
              </template>
            </datatable>
          </div>
        </div>
      </div>
      <div v-if="companydialog">
        <ModalSubdivisionEdit
          @toggle="dialogClose($event)"
          v-model="editCompanyItem"
          :subdivisions="subdivisions"
          :parent="companyActive"
          :multi="multidialog"
          :ids="ids"
        />
      </div>
      <v-row justify="center">
        <v-dialog v-model="isShowModalDepartment" max-width="700px">
          <FormDepartment
            :data="selectedDepartment"
            :departments="departments"
            @close="isShowModalDepartment = false"
            @store="getDepartments"
          />
        </v-dialog>
      </v-row>
    </div>
  </v-app>
</template>

<script>
//import {eventEmmitter} from "../app";
import Datatable from "../components/datatable";
import VuePagination from "../components/pagination";
import ModalSubdivisionEdit from "./users/ModalSubdivisionEdit";
import FormDepartment from "./users/FormDepartment";
import axios from "axios";
import AccessAdd from "./users/ModalAddUsersAccess";
import DepartmentAdd from "./users/ModalAddUsersDepartments";
import moment from "moment-timezone";

export default {
  name: "Users",
  data() {
    const afields = [
      {
        name: "avatar",
        title: "",
        style: "width: 50px; margin-right: 20px;",
        type: "img",
        click: this.showUser,
        header: { style: "width: 65px" },
      },
      {
        name: "fio",
        header: { text: this.$ml.get("users.fullname") },
        click: this.showUser,
      },
      {
        name: "department",
        header: {
          text: this.$ml.get("users.department"),
          style: "width: 200px",
        },
      },
      {
        name: "type_user",
        header: { text: this.$ml.get("users.status"), style: "width: 150px" },
      },
      {
        name: "id",
        header: { text: "ID", style: "width: 60px" },
      },
      {
        name: "ff",
        style: "color: red; font-size: 20px;",
        header: { style: "width: 2px" },
      },
    ];

    if (
      this.$auth.user().type_user == "admin" ||
      this.$auth.user().roles.includes("useradd") ||
      this.$auth.user().roles.includes("useredit") ||
      this.$auth.user().roles.includes("userdel")
    ) {
      afields.unshift({
        name: "_select",
        type: "checkbox",
        class: "check-select",
        style: "width: 10px;",
        click: this.select,
        header: {
          class: "check-select",
          type: "checkbox",
          click: this.headerSelect,
          value: "all",
        },
      });
    }

    return {
      ids: [],
      treeOpen: false,
      v: "all",
      mode: { val: "all", title: "Все" },
      totalItems: 0,
      afields,
      fields: [
        {
          name: "avatar",
          title: "",
          style: "width: 50px; margin-left: 33px;",
          type: "img",
          header: { style: "width: 115px" },
        },
        {
          name: "fio",
          header: {
            text: this.$ml.get("users.fullname"),
          },
        },
        {
          name: "type_user",
          header: { text: this.$ml.get("users.status"), style: "width: 150px" },
        },
        // {
        //   name: "companyName",
        //   header: { text: this.$ml.get("users.subdivision") },
        //   style: "width: 150px;"
        // },
        {
          name: "id",
          header: { text: "ID", style: "width: 70px" },
        },
      ],
      multidialog: false,
      selectUsers: [],
      showAccessDialog: false,
      showDepartmentDialog: false,
      sdvAction: "",
      rows: [],
      users: {
        all: {
          pagination: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 10,
            current_page: 1,
          },
          data: [],
        },
        // employee: {
        //   pagination: {
        //     total: 0,
        //     per_page: 2,
        //     from: 1,
        //     to: 10,
        //     current_page: 1,
        //   },
        //   data: [],
        // },
        // guest: {
        //   pagination: {
        //     total: 0,
        //     per_page: 2,
        //     from: 1,
        //     to: 10,
        //     current_page: 1,
        //   },
        //   data: [],
        // },
        deleted: {
          pagination: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 10,
            current_page: 1,
          },
          data: [],
        },
        blacks: {
          pagination: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 10,
            current_page: 1,
          },
          data: [],
        },
        blocks: {
          pagination: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 10,
            current_page: 1,
          },
          data: [],
        },
        errors: {
          pagination: {
            total: 0,
            per_page: 2,
            from: 1,
            to: 10,
            current_page: 1,
          },
          data: [],
        },
      },
      offset: 4,
      filter: "all",
      search: "",
      user: false,
      companyActive: {},
      tree: [],
      sdv: [],
      subdivisions: [],
      editCompanyItem: {},
      companydialog: false,
      sdivSelect: [],
      treeSelect: [],
      l: {
        lang: "en",
      },
      tabSelect: "all",
      leftSideBarTabSelected: "subdivisions",

      departments: [],
      selectedDepartment: null,
      isShowModalDepartment: false,
    };
  },
  components: {
    Datatable,
    VuePagination,
    ModalSubdivisionEdit,
    AccessAdd,
    DepartmentAdd,
    FormDepartment,
  },
  methods: {
    selectMode(item) {
      this.mode = item;
    },
    closeAccessDialog(event) {
      this.showAccessDialog = event;
      this.deselect();
      this.getUsers(this.v);
    },
    closeDepartmentDialog(event) {
      this.showDepartmentDialog = event;
      this.deselect();
      this.getUsers(this.v);
    },
    activeBlock(name) {
      return this.v == name ? " active" : "";
    },
    setTab(tab) {
      localStorage.setItem("terminal.users.tabs", tab);
      localStorage.removeItem("terminal.users." + tab + ".current_page");
      this.users[tab].pagination.current_page = 1;
      if (tab == "all") this.filter = tab;
      this.getUsers(tab);
      this.v = tab;
    },
    select(item, e) {
      item["_select"] = !item["_select"];
      e.target.checked = item["_select"];
    },
    headerSelect(val, e, items) {
      //val = e.target.checked;

      items = items || [];
      items.forEach((item) => {
        item["_select"] = e;
      });
    },
    deselect() {
      this.users[this.v].data.forEach((item) => {
        item["_select"] = false;
      });
    },
    multiSdv(action, tab) {
      this.sdvAction = action;
      this.tabSelect = tab;
      this.showAccessDialog = true;
    },
    multiDpt(tab) {
      this.tabSelect = tab;
      this.showDepartmentDialog = true;
    },
    multiBlock(act, us) {
      let url = "/user/blocked";
      if (act == "unblock") {
        url = "/user/unblocked";
      }
      axios.put(url, { ids: this.selectUsers[us] }).then((response) => {
        if (response.status == 200) {
          this.getUsers(this.v);
          this.deselect();

          if (act == "block") {
            this.$notify({
              group: "info",
              type: "success",
              text:
                this.selectUsers[us].length >= 2
                  ? this.$ml.get("message.usersBlockSuccess")
                  : this.$ml.get("message.userBlockSuccess"),
            });
          }
        }
      });
    },
    multiBlack(act, us) {
      let url = "/user/blacklisted";
      if (act == "unblack") {
        url = "/user/unblacklisted";
      }
      axios.put(url, { ids: this.selectUsers[us] }).then((response) => {
        if (response.status == 200) {
          this.getUsers(this.v);
          this.deselect();
        }
      });
    },
    multiDelete(us) {
      let url = "/user/delete";
      let _this = this;
      this.$dialog
        .confirm(
          `<h3>${this.$ml.get("message.Delete")}</h3>` +
            this.$ml.get("message.confirmDelete"),
          {
            loader: false,
            okText: this.$ml.get("button.delete"),
            cancelText: this.$ml.get("button.cancel"),
            backdropClose: true,
          }
        )
        .then(() => {
          axios.put(url, { ids: _this.selectUsers[us] }).then((response) => {
            if (response.status == 200) {
              _this.getUsers(_this.v);
              _this.deselect();

              this.$notify({
                group: "info",
                type: "success",
                text:
                  _this.selectUsers[us].length >= 2
                    ? this.$ml.get("message.usersDeleteSuccess")
                    : this.$ml.get("message.userDeleteSuccess"),
              });
            }
          });
        });
    },
    multiRefeature(us) {
      let i = 0;
      this.selectUsers[us].forEach((it) => {
        axios
          .put("/user/" + it + "/refeature")
          .then((response) => {
            i++;
            if (i >= this.selectUsers[us].length) {
              this.getUsers(this.v);
              this.deselect();
              this.$notify({
                group: "info",
                type: "success",
                text: this.$ml.get("message.refeature_success"),
              });
            }
          })
          .catch((err) => {
            i++;
            if (i >= this.selectUsers[us].length) {
              this.getUsers(this.v);
              this.deselect();
              this.$notify({
                group: "info",
                type: "error",
                text: err.response.data.message,
              });
            }
          });
        // console.log(i, this.selectUsers[us].length)
        // if (i >= this.selectUsers[us].length) {
        //   this.getUsers(this.v);
        //   this.deselect();
        // }
      });
    },
    clearAll() {
      let url = "/users/trash";
      let _this = this;
      this.$dialog
        .confirm(
          `<h3>${this.$ml.get("message.Delete")}</h3>` +
            this.$ml.get("message.confirmDelete"),
          {
            loader: false,
            okText: this.$ml.get("button.delete"),
            cancelText: this.$ml.get("button.cancel"),
            backdropClose: true,
          }
        )
        .then(() => {
          axios.delete(url).then((response) => {
            if (response.status == 200) {
              _this.getUsers("deleted");

              this.$notify({
                group: "info",
                type: "success",
                text: this.$ml.get("message.usersClearSuccess"),
              });
            }
          });
        });
    },
    multiRestore(us) {
      let url = "/user/restore";
      axios.put(url, { ids: this.selectUsers[us] }).then((response) => {
        if (response.status == 200) {
          this.getUsers("deleted");
        }
      });
    },
    multiClear(us) {
      let url = "/user/clear";
      let _this = this;
      this.$dialog
        .confirm(
          `<h3>${this.$ml.get("message.Delete")}</h3>` +
            this.$ml.get("message.confirmDelete"),
          {
            loader: false,
            okText: this.$ml.get("button.delete"),
            cancelText: this.$ml.get("button.cancel"),
            backdropClose: true,
          }
        )
        .then(() => {
          axios.put(url, { ids: _this.selectUsers[us] }).then((response) => {
            if (response.status == 200) {
              //_this.getUsers("all");
              _this.getUsers("deleted");

              this.$notify({
                group: "info",
                type: "success",
                text:
                  _this.selectUsers[us].length >= 2
                    ? this.$ml.get("message.usersClearSuccess")
                    : this.$ml.get("message.userClearSuccess"),
              });
            }
          });
        });
    },
    dialogClose(val) {
      this.companydialog = val;
      this.getSubdivisions();
    },
    selectCompany(item, e) {
      this.companyActive = item;
      if (e.shiftKey) {
        if (!this.treeSelect[item.id]) {
          this.treeSelect[item.id] = true;
        }
        return;
      } else {
        this.treeSelect = [];
      }
      this.users[this.v].pagination.current_page = 1;
      //this.companyActive = item;
      if (!this.treeSelect[item.id]) {
        this.treeSelect[item.id] = true;
      }
      localStorage.setItem("terminal.users.subdiv", JSON.stringify(item.id));
      this.getUsers(this.v);
    },
    isAddUser() {
      return (
        !this.l.cloud_connect &&
        (this.$auth.user().type_user == "admin" ||
          this.$auth.user().roles.includes("useradd") ||
          this.$auth.user().roles.includes("useredit") ||
          this.$auth.user().roles.includes("userdel"))
      );
    },
    isEditUser() {
      return (
        !this.l.cloud_connect &&
        (this.$auth.user().type_user == "admin" ||
          this.$auth.user().roles.includes("useredit"))
      );
    },
    isDelUser() {
      return (
        !this.l.cloud_connect &&
        (this.$auth.user().type_user == "admin" ||
          this.$auth.user().roles.includes("userdel"))
      );
    },
    isSdvEdit() {
      return (
        this.$auth.user().type_user == "admin" ||
        this.$auth.user().roles.includes("sdvedit")
      );
    },
    addCompany() {
      if (!this.isSdvEdit()) return;
      this.editCompanyItem = {
        id: 0,
        parent_id: this.companyActive.id || null,
        zones_id: null,
        name: "",
      };
      this.companydialog = true;
      this.multidialog = false;
      this.ids = [];
    },
    editCompany() {
      if (!this.isSdvEdit() || this.companyActive.id < 1) return;
      this.ids = [];
      this.treeSelect.forEach((v, id) => {
        this.ids.push(id);
      });

      console.log(this.treeSelect.length);
      if (this.ids.length > 1) {
        this.companydialog = true;
        this.multidialog = true;
        this.editCompanyItem = {};
      } else {
        if (!this.companyActive.id) return;
        this.editCompanyItem = this.companyActive;
        this.companydialog = true;
        this.multidialog = false;
      }
    },
    deleteCompany() {
      if (!this.isSdvEdit()) return;
      let options = {
        loader: false,
        okText: this.$ml.get("button.delete"),
        cancelText: this.$ml.get("button.cancel"),
        backdropClose: true,
      };
      let _this = this;
      this.$dialog
        .confirm(
          `<h3>${this.$ml.get("message.Delete")}</h3>` +
            this.$ml.get("message.confirmDelete"),
          {
            loader: false,
            okText: this.$ml.get("button.delete"),
            cancelText: this.$ml.get("button.cancel"),
            backdropClose: true,
          }
        )
        .then(function () {
          if (!_this.treeSelect.length) {
            axios
              .put("/subdivision/delete", { ids: [_this.companyActive.id] })
              .then((response) => {
                if (response.status == 200) {
                  if (response.data.status.code != 0) {
                    _this.errorMessage = response.data.status.message;
                  } else {
                    _this.getSubdivisions();
                  }
                }
              })
              .catch((err) => {
                _this.errorMessage = err.response.data.status.message;
              });
          } else {
            let ids = [];
            _this.treeSelect.forEach((v, id) => {
              ids.push(id);
            });

            axios.put("/subdivision/delete", { ids: ids }).then((response) => {
              if (response.status == 200) {
                if (response.data.status.code != 0) {
                  _this.errorMessage = response.data.status.message;
                } else {
                  _this.getSubdivisions();
                }
              }
            });
          }
        });
    },
    setTreeActiveClass(item) {
      if (item.id == this.companyActive.id || this.treeSelect[item.id]) {
        return "active";
      }
    },
    styleRow(item) {
      if (item["blacklisted"]) {
        return "background: #272D3D; color: #fff;";
      }
      if (item["blocked"]) {
        return "background: #8ec2f7; color: #000;";
      }
      if (item["_select"]) {
        return "background: #dddddd;";
      }
    },
    showUser(item) {
      this.$router.push("/user/" + item.id);
    },
    searchfn(value) {
      this.search = value;
      this.users["all"].pagination.current_page = 1;
      this.getUsers("all");
      this.user = false;
    },
    getUsers(type) {
      let values = {
        search: this.search,
        subdivision: this.getSubvisionsIds(),
        department: this.getDepartmentIds(),
      };
      if (this.leftSideBarTabSelected != "subdivisions") {
        values.subdivision = null;
      } else {
        values.department = null;
      }

      if (
        type == "all" ||
        type == "guest" ||
        type == "employee" ||
        type == "manager"
      ) {
        if (type != "all") values.typeuser = type;
        this.filter = type;
        type = "all";
      } else {
        values.mode = type;
      }
      values.page = this.users[type].pagination.current_page;
      let url = "/users";
      axios.get(url, { params: values }).then((response) => {
        if (response.data.status.code == 0) {
          localStorage.setItem(
            "terminal.users." + type + ".current_page",
            values.page
          );
          this.users[type] = this.normalizeData(response);

          this.totalItems = response.data.meta.pagination.total_items;
        }
      });
    },
    getSelectCount(us) {
      if (us != this.v) return 0;
      let count = 0;
      this.selectUsers[us] = [];
      this.users[us].data.forEach((item) => {
        if (item["_select"]) {
          this.selectUsers[us].push(item.id);
          count++;
        }
      });

      return count;
    },
    normalizeData(response) {
      let users = {};
      users.data = response.data.data ? response.data.data : [];
      users.pagination = response.data.meta.pagination || {};

      users.data.forEach((item) => {
        item._select = false;
        item.fio = (
          item.last_name +
          " " +
          item.first_name +
          " " +
          item.middle_name
        ).trim();
        if (item.photo) {
          item.avatar = "/avatar/small/" + item.photo;
        } else {
          item.avatar = "/avatar/small/avatar.png";
        }
        item.type_user = this.$ml.get("users." + item.type_user);
        item.ff = item.ff ? "!" : "";
      });
      return users;
    },
    searchblfn(value) {
      this.search = value;
      this.blacks.pagination.current_page = 1;
      this.getBlack();
      this.user = false;
    },
    getTree(items, parent) {
      let result = [];
      items.forEach((el) => {
        if (parent == el.parent_id) {
          let item = {
            id: el.id,
            name: el.name,
            parent_id: el.parent_id,
            zones_id: el.zones_id,
            access: el.access,
          };
          let children = this.getTree(items, el.id);
          if (children) {
            item.children = children;
          }
          result.push(item);
        }
      });
      return result;
    },
    getParents(id, arrays = []) {
      let out = [];
      if (arrays) {
        arrays.forEach((item) => {
          if (item.parent_id == id) {
            out.push(item.id);
            let ids = this.getParents(item.id, arrays);
            if (ids.length) out.push(ids);
          }
        });
      }
      return out;
    },
    getDepartmentIds() {
      if (!this.selectedDepartment) return;
      let out = [];
      out.push(this.selectedDepartment.id);
      let ids = this.getParents(this.selectedDepartment.id, this.departments);
      if (ids.length) out.push(ids);
      if (out.length) {
        return out.join(",");
      }
    },

    getSubvisionsIds() {
      if (!this.companyActive.id) return;
      let out = [];
      out.push(this.companyActive.id);
      let ids = this.getParents(this.companyActive.id, this.subdivisions);
      if (ids.length) out.push(ids);
      if (out.length) {
        return out.join(",");
      }
    },
    getSubdivisions() {
      axios.get("/subdivisions").then((response) => {
        if (response.status == 200) {
          let parents = [];
          this.subdivisions = response.data.data;
          this.subdivisions.forEach((el) => {
            el.__select = false;
            this.sdv[el.id] = el.name;
            parents[el.id] = el.parent_id;
          });
          this.tree = this.getTree(this.subdivisions, null);

          let subdiv = localStorage.getItem("terminal.users.subdiv");
          if (subdiv) {
            let id = JSON.parse(subdiv);
            this.subdivisions.forEach((el) => {
              if (el.id == id) {
                this.companyActive = el;
                return;
              }
            });
          }
          let npage = localStorage.getItem(
            "terminal.users." + this.v + ".current_page"
          );
          if (npage == null) npage = 1;
          this.users[this.v].pagination.current_page = parseInt(npage);
          this.treeOpen = true;
          this.getUsers(this.v);
        }
      });
    },
    setActiveStyle() {
      let e = $(".v-treeview-node__root a.active");
      if (e !== null) {
        $(".v-treeview-node__root").css("background-color", "#fff");
        let el = $(e).closest(".v-treeview-node__root");
        el.css("background-color", "#e2e2e2");
      }
    },
    reportErrors() {
      //console.log(this.users['errors'].data.length)
      if (this.users["errors"].data.length > 0) {
        // Получаем отчет о пользователях и ошибках
        let params = {
          page: this.users.errors.current_page,
          lang: this.l.lang,
        };
        let requestParams = {
          method: "get",
          params,
          url: "/report/usererrors",
          responseType: "blob",
        };

        axios.request(requestParams).then((response) => {
          if (response.status == 200) {
            let filename =
              "errors-" + moment().format("YYYYMMDDHHmmss") + ".xlsx";
            let url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: "application/xlsx",
              })
            );
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            this.$dialog
              .alert(this.$ml.get("users.notUsers"), {
                loader: false,
                okText: "OK",
                backdropClose: true,
              })
              .then(function (dialog) {});
          }
        });
      }
    },
    reportUsers() {
      //console.log(this.users['errors'].data.length)
      if (this.users["all"].data.length > 0) {
        // Получаем отчет о пользователях и ошибках
        let params = {
          page: this.users.errors.current_page,
          lang: this.l.lang,
          limit: -1,
          subdivision: this.getSubvisionsIds(),
          department: this.getDepartmentIds(),
          usertype: this.filter != "all" ? this.filter : "",
          search: this.search,
        };
        if (this.leftSideBarTabSelected != "subdivisions") {
          params.subdivision = null;
        } else {
          params.department = null;
        }
        let requestParams = {
          method: "get",
          params,
          url: "/report/users",
          responseType: "blob",
        };

        axios.request(requestParams).then((response) => {
          if (response.status == 200) {
            let filename =
              "users-" + moment().format("YYYYMMDDHHmmss") + ".xlsx";
            let url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: "application/xlsx",
              })
            );
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            this.$dialog
              .alert(this.$ml.get("users.notUsers"), {
                loader: false,
                okText: "OK",
                backdropClose: true,
              })
              .then(function (dialog) {});
          }
        });
      }
    },

    getDepartments() {
      axios("departments").then((response) => {
        this.departments = response.data.data;
      });
    },

    onSelectDepartment([department]) {
      this.selectedDepartment = department;
      console.log(this.selectedDepartment);
      this.getUsers(this.v);
    },

    addDepartment() {
      this.selectedDepartment = null;
      this.isShowModalDepartment = true;
    },

    editDepartment() {
      this.isShowModalDepartment = true;
    },

    deleteDepartment() {
      this.$dialog
        .confirm(
          `<h3>${this.$ml.get("message.Delete")}</h3>` +
            this.$ml.get("message.confirmDelete"),
          {
            loader: false,
            okText: this.$ml.get("button.delete"),
            cancelText: this.$ml.get("button.cancel"),
            backdropClose: true,
          }
        )
        .then(() => {
          axios.delete(`department/${this.selectedDepartment.id}`).then(() => {
            this.getDepartments();

            this.$notify({
              group: "info",
              type: "success",
              text: this.$ml.get("message.deleteSuccess"),
            });
          });
        });
    },
  },

  computed: {
    departmentsTree() {
      const getTree = (items, parent = null) => {
        let result = [];
        items.forEach((el) => {
          if (parent == el.parent_id) {
            let item = {
              id: el.id,
              name: el.name,
              parentId: el.parent_id,
            };
            let children = getTree(items, el.id);
            if (children) {
              item.children = children;
            }
            result.push(item);
          }
        });
        return result;
      };

      return getTree(this.departments);
    },

    isDepEdit() {
      return (
        this.$auth.user().type_user == "admin" ||
        this.$auth.user().roles.includes("depedit")
      );
    },
    isDepAdd() {
      return (
        this.$auth.user().type_user == "admin" ||
        this.$auth.user().roles.includes("depadd")
      );
    },
    isDepDel() {
      return (
        this.$auth.user().type_user == "admin" ||
        this.$auth.user().roles.includes("depdel")
      );
    },
  },

  mounted() {
    localStorage.setItem("terminal.target.page", "/users");
    if (localStorage.getItem("terminal.users.tabs") !== null) {
      this.v = localStorage.getItem("terminal.users.tabs");
      console.log(this.v);
    } else {
      console.log("DELETE:", localStorage.getItem("terminal.users.tabs"));
      localStorage.removeItem("terminal.users.all.current_page");
      localStorage.setItem("terminal.users.tabs", "all");
      this.users["all"].pagination.current_page = 1;
    }
    if (localStorage.getItem("ovision-ml")) {
      try {
        this.l = JSON.parse(localStorage.getItem("ovision-ml"));
      } catch (err) {
        console.error(err);
      }
    }
    if (this.l.cloud_connect) {
      this.afields[0].type = "text";
      this.afields[0].name = "";
      this.afields[0].header.type = "text";
    }
    this.getSubdivisions();
  },

  created() {
    this.getDepartments();
  },

  updated() {
    this.setActiveStyle();
  },
};
</script>

<style>
.check-select {
  margin-right: 0px;
}

.search-visitors-dashboard tbody tr td:first-of-type {
  width: auto;
}
.v-application ol,
.v-application ul {
  padding-left: 0px;
}
</style>
<style scoped>
.nav-tabs .nav-link {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.top-button-box {
  display: flex;
  width: 100%;
  margin-bottom: 0px;
  margin-left: 10px;
  /* flex-flow: row-reverse; */
}
.tab-content {
  padding: 15px;
  border-left: solid 1px #dee2e6;
  border-right: solid 1px #dee2e6;
  border-bottom: solid 1px #dee2e6;
  margin-bottom: 10px;

  /*box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);*/
}
.theme--light.v-application {
  background: none;
}
.btn.btn-primary {
  color: #fff;
}
/* .v-treeview-node__root! a.active {
  background: #666;
} */
.v-treeview-node__root a {
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
</style>
